import * as userAction from "../actions/geoLinks.action";
const geoLinks = (
  state = {
    status: null,
    loading: false,
    error: null,
    geoLinksData: null,
  },
  action,
) => {
  switch (action.type) {
    case userAction.GEOLINKS_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
      });
    case userAction.GEOLINKS_SUCCESS:
      return Object.assign({}, state, {
        geoLinksData: action?.geoLinksData,
        status: action.status,
        loading: false,
      });
    case userAction.GEOLINKS_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.GEOLINKS_RESET:
      return Object.assign({}, state, {
        geoLinksData: action?.geoLinksData,
        status: action.status,
        loading: false,
      });
    default:
      return state;
  }
};
export default geoLinks;
